
import Periodo from "./partials/Periodo.vue"
import { defineComponent, onMounted, computed } from "vue";
import { useStore } from "vuex";
import KTUserMenu from "@/layout/header/partials/UserMenu.vue";

export default defineComponent({
    name: "topbar",
    components: {
        KTUserMenu, Periodo
    },
    setup() {
        const store = useStore();

        const username: any = computed < any > (() => {
            return store.getters.currentUser.account;
        });

        const periods: any = computed < any > (() => {
            return store.getters.currentUser.periods;
        });
        

        onMounted(() => {
            //getUserName()
        });

        return {
            username,
            periods
        };
    },
});
